export default class PrinterLights {
	constructor() {
		this.blockName = "printer-lights";
		this.passNames = ["Primaries-sliders-offset-Y", "Primaries-sliders-offset-RGB"];
		this.curveNames = ["Primaries-Offset-Y", "Primaries-Offset-R", "Primaries-Offset-G", "Primaries-Offset-B"];
	}

	addBlock(blockNum = lutify.blocks.length) {
		UI.createAdjustmentBlockTemplate(this.blockName, blockNum);
		let element = UI.getAdjustmentBlock(blockNum);

		// $(element).find('.control-selector__items-container > span').on('click', (e, animate) => this.controlSelection(e.currentTarget, animate));
		$(element)
			.find(".btn-reset-block")
			.off("click")
			.on("click", _ => this.resetBlock($(element)));
		$(element)
			.find('.block-controls-container[data-control="sliders"] .slider-control')
			.on("dblclick", e => this.resetVerticalSlider($(e.currentTarget)));

		$(element)
			.find(".expand_options")
			.trigger("click", [false]);

		$(element)
			.find('.block-controls-container[data-control="sliders"] .slider-control')
			.on("input", e => this.verticalSliderHandler($(e.currentTarget)));
		$(element)
			.find('.block-controls-container[data-control="sliders"] .slider-input-control')
			.on("change", e => this.verticalSliderInputHandler($(e.currentTarget)));

		UI.initKnob(element);
			
		blocks.add({
			name: "printerLights",
			passes: this.addPasses(),
			blockNum,
			blendingMode: 0,
			blendingModeName: "Normal",
			curves: [],
			values: {
				sliders: {
					offset: { Y: 0, R: 0, G: 0, B: 0 },
				},
			},
		});

		this.slidersInit($(element));
		blocks.createCurves(this.curveNames, blockNum);
	}

	addPasses() {
		let passes = [];
		this.passNames.forEach(passName => {
			let shaderPass = gpu.createCurveShaderPass(passName);
			gpu.addPassToComposer(shaderPass, "toMiddle");
			passes.push(shaderPass);
		});

		return passes;
	}

	slidersInit($element) {
		$element.find('.block-controls-container[data-control="sliders"] .slider-control').slider({
			orientation: "vertical",
			width: 1,
			range: "min",
			min: -1,
			max: 1,
			step: 0.001,
			value: 0,
			change: (event, ui) => this.verticalSliderHandler(event, ui),
			slide: (event, ui) => this.verticalSliderHandler(event, ui),
		});

		$element.find('.block-controls-container[data-control="sliders"] .slider-control').each((index, sliderControl) => {
			let html = document.createElement("div");
			html.setAttribute("class", "slider-control-fill");
			$(sliderControl).append(html);
		});
	}

	verticalSliderHandler(event, ui) {
		let $sliderControlElement = $(event.target);
		let controlName = $sliderControlElement.data("curve").split("-")[0];
		let controlCurve = $sliderControlElement.data("curve").split("-")[1];
		let passIndex = $sliderControlElement.data("pass-index");

		lutify.getActiveBlock().values.sliders[controlName][controlCurve] = ui.value;
		lutify.getActiveBlock().activePassIndex = passIndex;
		lutify.getActiveBlock().passes[passIndex].enabled = true;

		if (controlCurve == "R" || controlCurve == "G" || controlCurve == "B") {
			let valueR = lutify.getActiveBlock().values.sliders[controlName]["R"];
			let valueG = lutify.getActiveBlock().values.sliders[controlName]["G"];
			let valueB = lutify.getActiveBlock().values.sliders[controlName]["B"];
			this[`${controlName}RGBCurve`]([valueR, valueG, valueB], false);
		} else {
			// curve Y
			this[`${controlName}${controlCurve}Curve`](lutify.getActiveBlock().values.sliders[controlName][controlCurve]);
		}

		let $sliderInputElement = $sliderControlElement.closest('.control-container').find(`.slider-input-control[data-curve="${controlName}-${controlCurve}"]`);
		$sliderInputElement.val(ui.value);

		this.updateSliderUI($(event.target).closest(".slider-control"), ui.value);
		blocks.checkSwitchHandler($(event.target).closest(".adjustment-block"));
	}

	verticalSliderInputHandler($sliderInputElement) {
		let controlName = $sliderInputElement.data("curve").split("-")[0];
		let controlCurve = $sliderInputElement.data("curve").split("-")[1];

		lutify.getActiveBlock().values.sliders[controlName][controlCurve] = $sliderInputElement.val();

		let $sliderControlElement = $sliderInputElement.closest('.control-container').find(`.slider-control[data-curve="${controlName}-${controlCurve}"]`);
		$sliderControlElement.slider("value", $sliderInputElement.val());

		blocks.checkSwitchHandler($sliderInputElement.closest(".adjustment-block"));
	}

	offsetYCurve(offsetVal) {
		let curve = lutify.getActiveBlock().curves[0].colorCurve;
		curve.points = [];

		if (offsetVal > 0) {
			curve.points.push({ x: 0.0, y: offsetVal * 0.003921 * 128 });
			curve.points.push({ x: 1.0 - Math.abs(offsetVal) * 0.003921 * 128, y: 1.0 });
		} else {
			curve.points.push({ x: Math.abs(offsetVal) * 0.003921 * 128, y: 0.0 });
			curve.points.push({ x: 1.0, y: 1.0 - Math.abs(offsetVal) * 0.003921 * 128 });
		}

		curve.draw();
		curve.updateValues();
		this.callGPUOffsetY(curve.rgb);
	}

	offsetRGBCurve(offsetValues, calcValue = true) {
		let curves = [];
		curves[0] = lutify.getActiveBlock().curves[1].colorCurve;
		curves[1] = lutify.getActiveBlock().curves[2].colorCurve;
		curves[2] = lutify.getActiveBlock().curves[3].colorCurve;

		offsetValues.forEach((offsetValue, index) => {
			curves[index].points = [];

			// For wheels
			if (calcValue) {
				offsetValue = 255 - offsetValue;
				curves[index].points.push({ x: (offsetValue / 255) * 0.003921 * 128, y: 0.0 });
				curves[index].points.push({ x: 1.0, y: 1.0 - (offsetValue / 255) * 0.003921 * 128 });
			}

			// For sliders
			else {
				if (offsetValue > 0) {
					curves[index].points.push({ x: 0.0, y: offsetValue * 0.003921 * 128 });
					curves[index].points.push({ x: 1.0 - Math.abs(offsetValue) * 0.003921 * 128, y: 1.0 });
				} else {
					curves[index].points.push({ x: Math.abs(offsetValue) * 0.003921 * 128, y: 0.0 });
					curves[index].points.push({ x: 1.0, y: 1.0 - Math.abs(offsetValue) * 0.003921 * 128 });
				}
			}

			curves[index].draw();
			curves[index].updateValues();
		});

		this.callGPUOffsetRGB(curves[0].rgb, curves[1].rgb, curves[2].rgb);
	}

	callGPUOffsetY(points) {
		let curveTexture = gpu.pointsToCurve(points);
		let passIndex = lutify.getActiveBlock().activePassIndex;

		lutify.getActiveBlock().passes[passIndex].uniforms["map"].value = curveTexture;
		gpu.render();
	}

	callGPUOffsetRGB(pointsR, pointsG, pointsB) {
		let curveTexture = gpu.RGBPointsToCurve(pointsR, pointsG, pointsB);
		let passIndex = lutify.getActiveBlock().activePassIndex;

		lutify.getActiveBlock().passes[passIndex].uniforms["map"].value = curveTexture;
		gpu.render();
	}

	resetBlock($element) {
		let $sliderInputControls = $element.find(".slider-input-control");
		$sliderInputControls.each(function() {
			$(this).val($(this).data("default-value"));
		});
		$sliderInputControls.trigger("change");
		lutify.getActiveBlock().passes.forEach(pass => (pass.enabled = false));
	}

	resetVerticalSlider($slider) {
		$slider.slider("value", 0);

		let targetCurveName = $slider.data("curve").split("-")[0];
		let targetCurve = $slider.data("curve").split("-")[1];
		let passIndex = $slider.data("pass-index");

		if (targetCurve == "Y") {
			lutify.getActiveBlock().passes[passIndex].enabled = false;
		} else {
			if (
				lutify.getActiveBlock().values.sliders[targetCurveName].R == 0 &&
				lutify.getActiveBlock().values.sliders[targetCurveName].G == 0 &&
				lutify.getActiveBlock().values.sliders[targetCurveName].B == 0
			) {
				lutify.getActiveBlock().passes[passIndex].enabled = false;
			}
		}
	}

	updateSliderUI($slider, sliderValue) {
		let $sliderControlElementHeight = $slider.height();
		let sliderControlFillHeight = Math.abs(($sliderControlElementHeight * sliderValue) / 2);
		let $sliderControlFillElement = $slider.find(".slider-control-fill");
		$sliderControlFillElement.css("height", `${sliderControlFillHeight}px`);

		if (sliderValue > 0) {
			$sliderControlFillElement.css({
				bottom: "50%",
				top: "initial",
			});
		} else if (sliderValue < 0) {
			$sliderControlFillElement.css({
				top: "50%",
				bottom: "initial",
			});
		}
	}

	applyChanges($block, values) {
		Object.keys(values).forEach(control => {
			Object.keys(values[control]).forEach(curve => {
				$block
					.find(`.block-controls-container[data-control="${control}"] .slider-input-control[data-curve="${curve}-Y"]`)
					.val(values[control][curve].Y);
				$block
					.find(`.block-controls-container[data-control="${control}"] .slider-input-control[data-curve="${curve}-R"]`)
					.val(values[control][curve].R);
				$block
					.find(`.block-controls-container[data-control="${control}"] .slider-input-control[data-curve="${curve}-G"]`)
					.val(values[control][curve].G);
				$block
					.find(`.block-controls-container[data-control="${control}"] .slider-input-control[data-curve="${curve}-B"]`)
					.val(values[control][curve].B);
			});
		});

		$block.find('.block-controls-container[data-control="sliders"] .slider-input-control').trigger("change");
	}
}
